export const arrowDownGraph = [
  '0 0 32 32',
  `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_10816_11724)">
  <path d="M15.625 18.625L8.125 11.125L11.25 8L5.625 2.375" stroke="#FA5252" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.625 18.625L15.625 18.625L15.625 13.625" stroke="#FA5252" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_10816_11724">
  <rect width="20" height="20" fill="white" transform="translate(20 0.5) rotate(90)"/>
  </clipPath>
  </defs>
  </svg>
  `,
]
